import membersActionTypes from './action-types';

export const fetchMembers = value => ({
  type: membersActionTypes.FETCH_MEMBERS,
  payload: value,
});

export const fetchMembersSuccess = value => ({
  type: membersActionTypes.FETCH_MEMBERS_SUCCESS,
  payload: value,
});

export const fetchMembersFail = value => ({
  type: membersActionTypes.FETCH_MEMBERS_FAIL,
  payload: value,
});

export const fetchMember = value => ({
  type: membersActionTypes.FETCH_MEMBER,
  payload: value,
});

export const fetchMemberSuccess = value => ({
  type: membersActionTypes.FETCH_MEMBER_SUCCESS,
  payload: value,
});

export const fetchMemberFail = value => ({
  type: membersActionTypes.FETCH_MEMBER_FAIL,
  payload: value,
});

export const updateUserBlockStatus = value => ({
  type: membersActionTypes.UPDATE_USER_BLOCK_STATUS,
  payload: value,
});

export const updateUserBlockStatusSuccess = value => ({
  type: membersActionTypes.UPDATE_USER_BLOCK_STATUS_SUCCESS,
  payload: value,
});

export const updateUserBlockStatusFail = value => ({
  type: membersActionTypes.UPDATE_USER_BLOCK_STATUS_FAIL,
  payload: value,
});

export const fetchMemberTransactions = value => ({
  type: membersActionTypes.FETCH_MEMBER_TRANSACTIONS,
  payload: value,
});

export const fetchMemberTransactionsSuccess = value => ({
  type: membersActionTypes.FETCH_MEMBER_TRANSACTIONS_SUCCESS,
  payload: value,
});

export const fetchMemberTransactionsFail = value => ({
  type: membersActionTypes.FETCH_MEMBER_TRANSACTIONS_FAIL,
  payload: value,
});

export const setFilteredMemberTransactions = value => ({
  type: membersActionTypes.SET_FILTERED_MEMBER_TRANSACTIONS,
  payload: value,
});

export const updateUserPoints = value => ({
  type: membersActionTypes.UPDATE_USER_POINTS,
  payload: value,
});

export const updateUserPointsSuccess = value => ({
  type: membersActionTypes.UPDATE_USER_POINTS_SUCCESS,
  payload: value,
});

export const updateUserPointsFail = value => ({
  type: membersActionTypes.UPDATE_USER_POINTS_FAIL,
  payload: value,
});

export const addUserSuccess = payload => ({
  type: membersActionTypes.ADD_USER_SUCCESS,
  payload,
});

export const addUserFail = payload => ({
  type: membersActionTypes.ADD_USER_FAIL,
  payload,
});

export const resetMemberTransaction = payload => ({
  type: membersActionTypes.RESET_MEMBER_TRANSACTION,
  payload,
});
